import React from "react";
import FileDisplay from "../../../utils/FileDisplay";
import { CloseIcon } from "../../../assets/icons";
import { ViewLabelwithDataBg } from "../../../components/View/ViewLabelwithData";

function ViewVendor({ visible, onClose, data }) {
  const handleOnClose = (e) => {
    if (e.target.id === "modal") onClose();
  };
  if (!visible) return null;
  return (
    <div
      id="modal"
      onClick={handleOnClose}
      className="bg-black bg-opacity-30 fixed inset-0 backdrop-blur-sm 
        flex justify-center items-center z-10"
    >
      <div className="bg-white p-2 rounded w-1/2 max-h-[calc(100vh-140px)] ">
        <div className="flex items-start justify-between px-5 py-2  rounded-t">
          <h3 className="text-xs 2xl:text-sm font-semibold">{"Vendor View"}</h3>
          <span
            className="h-6 w-6 text-2xl block cursor-pointer"
            onClick={onClose}
          >
            <CloseIcon/>
          </span>
        </div>
        <div className=" w-full max-h-[calc(100vh-180px)] overflow-y-auto ">
            <ViewLabelwithDataBg title="Name" value={data.vendor_name || "-"} />
            <ViewLabelwithDataBg title="Vender Type" value={data.vendor_type || "-"} />
            <div className="my-3 text-left">
              <p className="text-sm text-[#1D1818] font-semibold mb-1 pl-8">
                Documents
              </p>
              <div className=" flex flex-wrap">
                {data?.document_type.length > 0 &&
                  data?.document_type.map((i) => {
                    return (
                      <div className=" m-1">
                        <FileDisplay data={i} view={true} />
                      </div>
                    );
                  })}
              </div>
            </div>
        </div>
      </div>
    </div>
  );
}

export default ViewVendor;
